module.exports = __webpack_public_path__ + "static/media/qtum.e706f924.png";